import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import Multiselect from '../CreateModal/components/Multiselect'
import RadioInput from 'components/Radio/RadioInput'
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  useEffect(async () => {}, [])

  const types = [
       {
          label:"Info",
          value:"info"
       },
       {
          label:"Success",
          value:"success"
       },
       {
          label:"Warning",
          value:"warning"
       },
       {
          label:"Error",
          value:"error"
       },
       {
          label:"Reminder",
          value:"reminder"
       },
  ]

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [message,setMessage] = useState(data?.message)

    const handleSubmit = async (e) => {
      e.preventDefault()
      // setProcessing(true);

      const typeField = e.target.type?.value
      const parsedType = JSON.parse(typeField)

      const payload = {
        _id: data._id,
        title: e.target.title.value,
        message,
        type:parsedType?.value
      }
      const { response } = await AppService.notification.update({
        payload: payload,
      })
       
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    return (
      <MDModal open={open} onClose={onClose} width={700} height={600}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form">
            <MDTypography variant="h5" mb={2}>
              Notification
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Title
              </MDTypography>
              <MDInput
                label="Title"
                placeholder="Title"
                name="title"
                fullWidth
                defaultValue={data.title}
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Message
              </MDTypography>
              <Editor handleChange={setMessage} data={message}/>
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Type
              </MDTypography>
              <Multiselect
                data={types}
                edit_data={types?.filter((item) => item?.value === data?.type)}
                isMulti={false}
                name="type"
              />
            </MDBox>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Edit
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton
        size="small"
        sx={{ marginRight: 2 }}
        color="info"
        variant="contained"
        onClick={handlemodal}
      >
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default EditModal
